import { useEffect, useState } from "react";
import TableWrapper from "components/Wrapper/TableWrapper";
import { apiUrls } from "constants/apiUrls";
import InvoiceItemForm from "containers/admin/Invoice/InvoiceItemForm";
import { Badge, Button, Card, Col, Form, FormCheck, Modal, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toDDMMYYYY, toDDMMYYYYHHMMSS } from "utils/dateFormatter";
import TableActionsWrapper from "components/Wrapper/TableActionsWrapper";
import ProgressLoader from "components/Loader/ProgressLoader";
import { Download, FileExcel, FiletypeCsv, PencilSquare, Plus, Trash } from "react-bootstrap-icons";
import { appRoutesUrls } from "constants/appRoutesUrls";
import { invoiceService } from "services/invoiceService";
import InvoiceHeaderWrapper from "components/Wrapper/InvoiceHeaderWrapper";
import { completeOnConfirm, deleteOnConfirm } from 'components/Confirm/ConfirmDialog';
import { toast } from "react-toastify";
import { saveAs } from 'file-saver';
import { commonMessage } from "constants/commonMessage";
import { BiRefresh, BiRightArrow, BiRupee, BiSolidChevronLeft } from "react-icons/bi";
import { bgInvoiceStatus, bgPaymentStatus } from "utils/bgColor";
import { invoiceStatus } from "constants/invoice/invoiceStatus";
import { DataNotFound } from "components/Alerts/Alerts";
import InvoicePaymentForm from "./InvoicePaymentForm";
import { roundTo } from "utils/numberFormatter";
import InvoiceForm from "./InvoiceForm";

const InvoiceDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState();
    const [invoiceItemId, setInvoiceItemId] = useState();
    const [showMore, setShowMore] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [showItemModal, setShowItemModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState(false);
    const pageTitle = "Invoice Details";

    useEffect(() => {
        getInvoiceDetails();
    }, [id]);

    const getInvoiceDetails = () => {
        if (id > 0) {
            setIsLoader(true);
            setMessage();
            invoiceService.getInvoiceDetails(apiUrls.getInvoiceDetails(id)).then(res => {
                setIsLoader(false);
                if (res)
                    setInvoiceDetails(res)
                else {
                    setMessage(commonMessage.notFound(pageTitle));
                    toast.warn(commonMessage.notFound(pageTitle));
                }
            }).catch((err) => setIsLoader(false));
        }
    }

    const deleteInvoiceItem = (invoiceItemId) => {
        if (invoiceItemId > 0) {
            setIsLoader(true);
            invoiceService.deleteInvoiceItem(apiUrls.deleteInvoiceItem(invoiceItemId)).then(res => {
                setIsLoader(false);
                toast.success("Invoice item deleted successfully");
                getInvoiceDetails();
            }).catch((err) => setIsLoader(false));
        }
    }

    const completeInvoice = (invoiceId) => {
        if (invoiceId > 0) {
            setIsLoader(true);
            invoiceService.completeInvoice(apiUrls.completeInvoice(invoiceId)).then(res => {
                setIsLoader(false);
                toast.success("Invoice moved to completed status");
                getInvoiceDetails(invoiceId);
            }).catch((err) => setIsLoader(false));
        }
    }

    const downloadInvoice = (invoiceId) => {
        if (invoiceId) {
            setIsLoader(true);
            invoiceService.downloadInvoice(apiUrls.downloadInvoice(invoiceId)).then(res => {
                setIsLoader(false);
                var blob = new Blob([res], { type: "application/pdf;charset=utf-8" });
                saveAs(blob, `Invoice_${invoiceId}.pdf`);
            }).catch((err) => setIsLoader(false));
        }
    }

    const handleExport = (option) => {
        alert(option);
    }

    const openInvoiceItemModal = (invoiceItemId) => {
        setInvoiceItemId(invoiceItemId);
        setShowItemModal(true);
    }

    const onItemSave = () => {
        setShowItemModal(false);
        getInvoiceDetails();
    }

    const onPaymentSave = () => {
        setShowPaymentModal(false);
        getInvoiceDetails();
    }

    const onInvoiceSave = () => {
        setShowInvoiceModal(false);
        getInvoiceDetails();
    }

    return (
        <>
            {isLoader && <ProgressLoader />}

            {message && <DataNotFound title="Invoice Details"> Click here to go <Link to={appRoutesUrls.invoices()}> Invoices</Link> </DataNotFound>}

            {!message && invoiceDetails?.invoice?.id > 0 &&
                <>
                    <Card className='card-default'>
                        <Card.Body>
                            <Card.Title>
                                <span className="hand me-1">
                                    <BiSolidChevronLeft size={26} onClick={() => navigate(appRoutesUrls.customerInvoices(invoiceDetails?.customer?.id))} />
                                </span>
                                Invoice Details - <b>{invoiceDetails?.customer?.name}</b>&nbsp;
                                <Badge bg={bgInvoiceStatus(invoiceDetails?.invoice?.invoiceStatus)}>
                                    {invoiceDetails?.invoice?.invoiceStatus}
                                </Badge> /&nbsp;
                                <Badge bg={bgPaymentStatus(invoiceDetails?.invoice?.paymentStatus)}>
                                    {invoiceDetails?.invoice?.paymentStatus}
                                </Badge>
                                <BiRefresh size={32} onClick={() => getInvoiceDetails()} className="hand float-end text-secondary" title="Refresh" />
                            </Card.Title>
                            <InvoiceHeaderWrapper>
                                <Row className="justify-content-center">
                                    <Col md={9}>
                                        <div>
                                            <b>Address:</b> {invoiceDetails?.customer?.address}<br />
                                            <b>Email:</b> {invoiceDetails?.customer?.email}<br />
                                            <b>Contact.:</b> {invoiceDetails?.customer?.mobileNo}<br />
                                            <b>GSTIN No.:</b> {invoiceDetails?.customer?.gstIn}
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div>
                                            <b>INV ID:</b> {invoiceDetails?.invoice?.id}
                                            {invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.inProgress && (
                                                <Button
                                                    size='sm'
                                                    variant="secondary"
                                                    className='btn-action float-end'
                                                    onClick={() => setShowInvoiceModal(true)}
                                                    title="Edit Invoice">
                                                    <PencilSquare />
                                                </Button>
                                            )}
                                            <br />
                                            <b>Invoice No:</b> {invoiceDetails?.invoice?.invoiceNo}<br />
                                            <b>Invoice Date:</b> {toDDMMYYYY(invoiceDetails?.invoice?.invoiceDate)}<br />
                                            <b>Date:</b>
                                        </div>
                                    </Col>
                                    {invoiceDetails?.invoice?.invoiceNotes && (
                                        <Col md={12} className="text-center fst-italic mt-1">
                                            <strong>Invoice Notes:</strong> {invoiceDetails?.invoice?.invoiceNotes}
                                        </Col>
                                    )}
                                </Row>
                            </InvoiceHeaderWrapper>
                            <TableActionsWrapper>
                                {invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.inProgress && (
                                    <>
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            type="button"
                                            className='mw-100'
                                            onClick={() => openInvoiceItemModal(0)}>
                                            <Plus size={24} /> Item ({invoiceDetails?.invoiceItems?.length})
                                        </Button>
                                    </>
                                )}
                                {invoiceDetails?.invoiceItems?.length > 0 && (
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        type="button"
                                        className='mw-100 ms-1'
                                        onClick={() => downloadInvoice(invoiceDetails?.invoice?.id)}>
                                        <Download size={18} /> Download ({roundTo(invoiceDetails?.invoice?.invoiceAmount)})
                                    </Button>
                                )}
                                {invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.inProgress && invoiceDetails?.invoiceItems?.length > 0 && (
                                    <Button
                                        size="sm"
                                        variant="success"
                                        type="button"
                                        className='mw-100 ms-1'
                                        onClick={() => completeOnConfirm(invoiceDetails?.invoice?.id, completeInvoice, null)}>
                                        <BiRightArrow size={20} /> Complete
                                    </Button>
                                )}
                                {invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.completed && (
                                    <>
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            type="button"
                                            className='mw-100 ms-1'
                                            onClick={() => setShowPaymentModal(true)}>
                                            <BiRupee size={20} />Payment ({roundTo(invoiceDetails?.invoice?.paidAmount)})
                                        </Button>
                                    </>
                                )}
                                <FormCheck
                                    type="switch"
                                    className='ms-2 float-end'
                                    label=""
                                    onChange={() => setShowMore(!showMore)}
                                    title={`Show ${showMore ? 'Less' : 'More'} Columns`}
                                />
                                <Button
                                    size="sm"
                                    type="button"
                                    variant="info"
                                    className='ms-1 btn-export float-end'
                                    onClick={() => handleExport('csv')}
                                    title="Export to CSV">
                                    <FiletypeCsv size={15} />
                                </Button>
                                <Button
                                    size="sm"
                                    type="button"
                                    variant="primary"
                                    className='ms-1 btn-export float-end'
                                    onClick={() => handleExport('excel')}
                                    title="Export to Excel">
                                    <FileExcel size={15} />
                                </Button>
                            </TableActionsWrapper>
                            <TableWrapper>
                                <Table striped hover responsive size='sm'>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '60px' }}>Action</th>
                                            <th style={{ width: '50px' }}>No.</th>
                                            <th style={{ width: '100px' }}>Item Date</th>
                                            <th style={{ width: '100px' }}>Ch.No</th>
                                            <th style={{ minWidth: '200px' }}>Item Description</th>
                                            <th>HSNC</th>
                                            <th style={{ textAlign: 'right' }}>Qty</th>
                                            <th style={{ textAlign: 'right' }}>Unit Price</th>
                                            <th style={{ textAlign: 'right' }}>Amount</th>
                                            {showMore &&
                                                <>
                                                    <th>Added Date</th>
                                                    <th>Added By</th>
                                                    <th>Modified Date</th>
                                                    <th>Modified By</th>
                                                </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceDetails?.invoiceItems && invoiceDetails?.invoiceItems.map((invoiceItem, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <Button
                                                        variant="outline-primary"
                                                        className='btn-action ms-1'
                                                        size='sm'
                                                        onClick={() => openInvoiceItemModal(invoiceItem.id)}
                                                        disabled={invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.completed}>
                                                        <PencilSquare />
                                                    </Button>
                                                    {invoiceItem.isActive &&
                                                        <Button
                                                            variant="outline-danger"
                                                            onClick={() => deleteOnConfirm(invoiceItem.id, deleteInvoiceItem, null)}
                                                            className='btn-action ms-1'
                                                            size='sm'
                                                            disabled={invoiceDetails?.invoice?.invoiceStatus === invoiceStatus.completed}>
                                                            <Trash />
                                                        </Button>
                                                    }
                                                </td>
                                                <td>{(index + 1)}</td>
                                                <td>{toDDMMYYYY(invoiceItem.itemDate)}</td>
                                                <td>{invoiceItem.challanNo}</td>
                                                <td>{invoiceItem.itemName}</td>
                                                <td>{invoiceItem.hsnCode}</td>
                                                <td align='right'>{invoiceItem.quantity}</td>
                                                <td align='right'>{roundTo(invoiceItem.unitPrice)}</td>
                                                <td align='right'>{roundTo(invoiceItem.itemAmount)}</td>
                                                {showMore &&
                                                    <>
                                                        <td>{toDDMMYYYYHHMMSS(invoiceItem.addedDate)}</td>
                                                        <td>{invoiceItem.addedBy}</td>
                                                        <td>{toDDMMYYYYHHMMSS(invoiceItem.modifiedDate)}</td>
                                                        <td>{invoiceItem.modifiedBy}</td>
                                                    </>
                                                }
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot style={{ textAlign: 'right' }}>
                                        <tr>
                                            <th colSpan={8}>Items Amount</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.itemsAmount)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>- Discount</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.disAmount)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>Total Amount</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.totalAmount)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>+ CGST ({invoiceDetails?.invoice?.gstPerc2}%)</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.gstAmount2)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>+ IGST ({invoiceDetails?.invoice?.gstPerc2}%)</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.gstAmount2)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>+ Prev. Balance</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.prevBalance)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                        <tr>
                                            <th colSpan={8}>Invoice Amount</th>
                                            <th>{roundTo(invoiceDetails?.invoice?.invoiceAmount)}</th>
                                            {showMore && <th colSpan={4}></th>}
                                        </tr>
                                    </tfoot>
                                </Table>
                            </TableWrapper>
                        </Card.Body>
                    </Card>

                    <Modal size="md" backdrop="static" centered show={showItemModal} onHide={() => setShowItemModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {invoiceItemId ? 'Edit' : 'Add'} Invoice Item<br />
                                <small><b>{invoiceDetails?.customer?.name}</b> <Badge bg="secondary">INV ID: {invoiceDetails?.invoice?.id}</Badge></small>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <InvoiceItemForm
                                id={invoiceItemId}
                                customerId={invoiceDetails?.customer?.id}
                                invoiceId={invoiceDetails?.invoice?.id}
                                onSave={onItemSave}
                                onCancel={() => setShowItemModal(false)} />
                        </Modal.Body>
                    </Modal>

                    <Modal size="md" backdrop="static" centered show={showPaymentModal} onHide={() => setShowPaymentModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Invoice Payment<br />
                                <small><b>{invoiceDetails?.customer?.name}</b> <Badge bg="secondary">INV ID: {invoiceDetails?.invoice?.id}</Badge></small>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <InvoicePaymentForm
                                id={invoiceItemId}
                                customerId={invoiceDetails?.customer?.id}
                                invoiceId={invoiceDetails?.invoice?.id}
                                invoiceNo={invoiceDetails?.invoice?.invoiceNo}
                                invoiceAmount={roundTo(invoiceDetails?.invoice?.invoiceAmount)}
                                paidAmount={roundTo(invoiceDetails?.invoice?.paidAmount)}
                                paymentStatus={invoiceDetails?.invoice?.paymentStatus}
                                invoiceNotes={invoiceDetails?.invoice?.invoiceNotes}
                                onSave={onPaymentSave}
                                onCancel={() => setShowPaymentModal(false)} />
                        </Modal.Body>
                    </Modal>

                    <Modal size="md" backdrop="static" centered show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Edit Invoice<br />
                                <small><b>{invoiceDetails?.customer?.name}</b> <Badge bg="secondary">INV ID: {invoiceDetails?.invoice?.id}</Badge></small>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <InvoiceForm
                                customerId={invoiceDetails?.customer?.id}
                                invoiceId={invoiceDetails?.invoice?.id}
                                invoiceNo={invoiceDetails?.invoice?.invoiceNo}
                                invoiceDate={invoiceDetails?.invoice?.invoiceDate}
                                itemsAmount={roundTo(invoiceDetails?.invoice?.itemsAmount)}
                                disAmount={roundTo(invoiceDetails?.invoice?.disAmount)}
                                totalAmount={roundTo(invoiceDetails?.invoice?.totalAmount)}
                                prevBalance={roundTo(invoiceDetails?.invoice?.prevBalance)}
                                gstPerc={invoiceDetails?.invoice?.gstPerc}
                                onSave={onInvoiceSave}
                                onCancel={() => setShowInvoiceModal(false)} />
                        </Modal.Body>
                    </Modal>
                </>
            }
        </>
    )
}

export default InvoiceDetails;